/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateSqlEngineInput {
  /**
  * The name of the SQL engine
  */
  'name': string;
  /**
  * The type of the SQL engine
  */
  'engineType': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineType",
      "baseName": "engineType",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateSqlEngineInput.attributeTypeMap;
  }

  public constructor() {
  }
}

